import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import { get } from 'lodash';
import FavIcon from 'react-favicon';
import CircularProgress from '@material-ui/core/CircularProgress';

import { ChatBox } from 'components';
import immutableToJS from 'helpers/immutableToJS';
import {
  isDistributor,
  isFarmer,
  isRestaurant,
  isConsumer,
  isPublic,
} from 'helpers/utils';
import { refreshToken } from 'redux/auth/actions';
import {
  currentMemberSelector,
  currentUserRoleSelector,
  currentUserSelector,
} from 'redux/auth/selectors';
import {
  listBrands,
  listFaqs,
  listFeatures,
  listGlobals,
  listPacks,
  listPermissions,
  listRoles,
  listTags,
  listTeamMembers,
  listTutorials,
  listUoms,
  listHomeSections,
  listAboutPage,
} from 'redux/options/actions';
import { getRequestingSelector, selectState } from 'redux/selectors';
import { setHotNotification } from 'redux/ui/actions';

class Main extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    currentMember: PropTypes.shape({}),
    currentUser: PropTypes.shape({}),
    currentUserRoleName: PropTypes.string,
    history: PropTypes.shape({}),
    brands: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    globals: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    brandsRequesting: PropTypes.bool,
    faqsRequesting: PropTypes.bool,
    featuresRequesting: PropTypes.bool,
    globalsRequesting: PropTypes.bool,
    packsRequesting: PropTypes.bool,
    permissionsRequesting: PropTypes.bool,
    rolesRequesting: PropTypes.bool,
    tagsRequesting: PropTypes.bool,
    teamMembersRequesting: PropTypes.bool,
    tokenInfo: PropTypes.shape({
      accessToken: PropTypes.string,
      roleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    tutorialsRequesting: PropTypes.bool,
    uomsRequesting: PropTypes.bool,

    listBrands: PropTypes.func.isRequired,
    listFaqs: PropTypes.func.isRequired,
    listFeatures: PropTypes.func.isRequired,
    listGlobals: PropTypes.func.isRequired,
    listPacks: PropTypes.func.isRequired,
    listPermissions: PropTypes.func.isRequired,
    listRoles: PropTypes.func.isRequired,
    listTags: PropTypes.func.isRequired,
    listTeamMembers: PropTypes.func.isRequired,
    listTutorials: PropTypes.func.isRequired,
    listUoms: PropTypes.func.isRequired,
    refreshToken: PropTypes.func.isRequired,
    setHotNotification: PropTypes.func.isRequired,
    listHomeSections: PropTypes.func.isRequired,
    listAboutPage: PropTypes.func.isRequired,
  };

  static defaultProps = {
    tokenInfo: {},
    currentMember: null,
    currentUser: {},
    currentUserRoleName: '',
    history: {},
    brandsRequesting: false,
    faqsRequesting: false,
    featuresRequesting: false,
    globalsRequesting: false,
    packsRequesting: false,
    permissionsRequesting: false,
    rolesRequesting: false,
    tagsRequesting: false,
    teamMembersRequesting: false,
    tutorialsRequesting: false,
    uomsRequesting: false,
  };

  static childContextTypes = {
    accessToken: PropTypes.string,
    currentMember: PropTypes.shape({}),
    currentUser: PropTypes.shape({}),
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isMember: PropTypes.bool,
    isRestaurant: PropTypes.bool,
    isConsumer: PropTypes.bool,
    isPublic: PropTypes.bool,
    noAutoPay: PropTypes.bool,
    noDistributor: PropTypes.bool,
    payOnline: PropTypes.bool,
    brands: PropTypes.shape({}),
    globals: PropTypes.shape({}),
    tutorials: PropTypes.shape({}),

    setHotNotification: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = { loading: false };

    setInterval(() => {
      if (this.elements && this.elements.length) {
        setTimeout(() => {
          for (let i = 0; i < this.elements.length; i++) {
            this.elements[i].classList.remove('update-animation');
          }
        }, 2000);
      } else {
        this.elements = document.getElementsByClassName('update-animation');
      }
    }, 100);

  }

  getChildContext() {
    const { brands, globals, tokenInfo, tutorials } = this.props;
    const groupedTutorials = {};

    tutorials.forEach(({ name, ...data }) => {
      groupedTutorials[name] = data;
    });

    const globalsObject = {};
    globals.forEach(({ name, value }) => {
      globalsObject[name] = value;
    });

    const brandsObject = {};
    brands.forEach(({ name, value }) => {
      brandsObject[name] = value;
    });

    return {
      accessToken: tokenInfo && tokenInfo.accessToken,
      currentMember: this.props.currentMember,
      currentUser: this.props.currentUser,
      isFarmer: isFarmer(this.props.currentUserRoleName),
      isDistributor: isDistributor(this.props.currentUserRoleName),
      isMember: !!this.props.currentMember,
      isRestaurant: isRestaurant(this.props.currentUserRoleName),
      isConsumer: isConsumer(this.props.currentUserRoleName),
      isPublic: !(tokenInfo && tokenInfo.accessToken),
      payOnline: globalsObject.payOnline === 'true',
      tutorials: groupedTutorials,
      brands: brandsObject,
      globals: globalsObject,
      noAutoPay: process.env.AUTOPAY !== 'TRUE',
      noDistributor: globalsObject.disableDistributor === 'true',
      setHotNotification: this.props.setHotNotification,
    };
  }

  componentWillMount() {
    // load all global options
    const {
      listBrands,
      listFaqs,
      listFeatures,
      listGlobals,
      listPacks,
      listPermissions,
      listRoles,
      listTags,
      listTeamMembers,
      listTutorials,
      listUoms,
      refreshToken,
      listHomeSections,
      listAboutPage,
    } = this.props;

    listBrands();
    listFaqs();
    listFeatures();
    listGlobals();
    listPacks();
    listPermissions();
    listRoles();
    listTags();
    listTeamMembers();
    listTutorials();
    listUoms();
    listHomeSections();
    listAboutPage();

    setTimeout(() => {
      const { tokenInfo } = this.props;
      if (tokenInfo && tokenInfo.accessToken) {
        refreshToken();
      }
    }, 1000);
  }

  // componentWillReceiveProps({
  //   tokenInfo,
  // }) {
  //   if ((tokenInfo.accessToken !== this.props.tokenInfo.accessToken) &&
  //     tokenInfo.accessToken &&
  //     (!this.props.tokenInfo.accessToken ||
  //       tokenInfo.user.roleId !== this.props.tokenInfo.roleId
  //     )
  //   ) {
  //     this.setState({ loading: true });
  //     window.location.reload();
  //   }
  // }

  componentDidUpdate() {
    const { brands } = this.props;
    const favIcon = (brands.find(brand => brand.name === 'favIcon') || {}).value;
    if (favIcon) {
      const favIconBadgeColor = (brands.find(brand => brand.name === 'favIconBadgeColor') || {}).value || '#FF0000';
      // init favicon
      window.favicon = new Favico({
        position: 'up',
        animation: 'slide',
        bgColor: favIconBadgeColor,
      });
    }
  }

  render() {
    const {
      brands,
      brandsRequesting,
      children,
      currentUser,
      currentMember,
      history,
      faqsRequesting,
      featuresRequesting,
      globalsRequesting,
      packsRequesting,
      permissionsRequesting,
      rolesRequesting,
      tagsRequesting,
      teamMembersRequesting,
      tutorialsRequesting,
      uomsRequesting,
    } = this.props;

    const { loading } = this.state;

    // show loading indicator until packs, roles, tags, uoms,
    // payment terms, price tiers, tutorials are loading.
    if (brandsRequesting || faqsRequesting || featuresRequesting || globalsRequesting
      || packsRequesting || permissionsRequesting || rolesRequesting || tagsRequesting
      || teamMembersRequesting || uomsRequesting || tutorialsRequesting) {
      return (
        <div className="main-progress">
          <CircularProgress />
        </div>
      );
    }

    const title = (brands.find(brand => brand.name === 'title') || {}).value;
    const description = (brands.find(brand => brand.name === 'description') || {}).value;
    const favIcon = (brands.find(brand => brand.name === 'favIcon') || {}).value;
    const currentUserRole = get(currentUser, 'organizations.0.account.currentRoleId');
    const currentOrgRole = get(currentUser, 'account.currentRoleId');
    const currentUserEmail = get(currentUser, 'organizations.0.account.email');
    const currentOrgEmail = get(currentUser, 'account.email');

    let chatBoxDisplayed = false;

    if (currentUserRole) {
      chatBoxDisplayed = currentUserEmail === currentOrgEmail;
    } else {
      chatBoxDisplayed = currentOrgRole ? true : chatBoxDisplayed;
    }

    return (
      <div key={currentUser.id} className={`chat-box-${chatBoxDisplayed}`}>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
        </Helmet>
        <FavIcon url={favIcon} />
        {children}
        {
          (currentUserRole || currentOrgRole) && <ChatBox />
        }
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('auth', 'tokenInfo')(state),
  ...selectState('options', 'brands')(state),
  ...selectState('options', 'globals')(state),
  ...selectState('options', 'tutorials')(state),
  faqsRequesting: getRequestingSelector('options', 'faqs')(state),
  featuresRequesting: getRequestingSelector('options', 'features')(state),
  packsRequesting: getRequestingSelector('options', 'packs')(state),
  permissionsRequesting: getRequestingSelector('options', 'permissions')(state),
  rolesRequesting: getRequestingSelector('options', 'roles')(state),
  tagsRequesting: getRequestingSelector('options', 'tags')(state),
  teamMembersRequesting: getRequestingSelector('options', 'teamMembers')(state),
  uomsRequesting: getRequestingSelector('options', 'uoms')(state),
  currentMember: currentMemberSelector(state),
  currentUser: currentUserSelector(state),
  currentUserRoleName: currentUserRoleSelector(state),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  listBrands: () => dispatch(listBrands()),
  listFaqs: () => dispatch(listFaqs()),
  listFeatures: () => dispatch(listFeatures()),
  listGlobals: () => dispatch(listGlobals()),
  listPacks: () => dispatch(listPacks()),
  listPermissions: () => dispatch(listPermissions()),
  listRoles: () => dispatch(listRoles()),
  listTags: () => dispatch(listTags()),
  listTeamMembers: () => dispatch(listTeamMembers()),
  listTutorials: () => dispatch(listTutorials()),
  listUoms: () => dispatch(listUoms()),
  refreshToken: () => dispatch(refreshToken()),
  setHotNotification: hotNotification => dispatch(setHotNotification(hotNotification)),
  listHomeSections: () => dispatch(listHomeSections()),
  listAboutPage: () => dispatch(listAboutPage()),
});

export default compose(
  setDisplayName('Main'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  immutableToJS,
)(Main);
